import * as DOMUtils from "history/DOMUtils";

const PREFIX = "onlineRetail.";

function enabled(): boolean {
    return DOMUtils.canUseDOM && typeof sessionStorage !== "undefined";
}

/**
 * @deprecated - Consider using storageUtils.ts
 */
export function set(key: string, value: string): void {
    if (enabled()) {
        sessionStorage.setItem(`${PREFIX}${key}`, value);
    }
}

/**
 * @deprecated - Consider using storageUtils.ts
 */
export function remove(key: string): void {
    if (enabled()) {
        sessionStorage.removeItem(`${PREFIX}${key}`);
    }
}

/**
 * @deprecated - Consider using storageUtils.ts
 */
export function get<T = string>(key: string, defaultValue: T | null = null): T | null {
    if (enabled()) {
        const value = sessionStorage.getItem(`${PREFIX}${key}`) as T | null;
        return typeof value !== "undefined" && value !== null ? value : defaultValue;
    }
    return defaultValue;
}
